// Copyright (C) 2019 TANNER AG

import React, { useState, useEffect } from "react";
import { compose } from "recompose";
import * as PropTypes from"prop-types";
import { withApollo } from "react-apollo";
import { withStore } from "./store/withstore";
import query from "./queries/translations";

export const TranslationContext = React.createContext({
	translations: {},
	translate: (slug) => null,
	format: () => null,
	language: "DE"
});

const TranslationProvider = (props) => {
	const [translations, setTranslations] = useState({});
	const { language } = props.store;

	useEffect(() => {
		const fetchTranslations = async() => {
			const res = await props.client.query({ query, variables: { language }, fetchPolicy: "network-only" });
			const formatted = {};

			res.data.tcoTranslations.forEach((value) => {
				formatted[value.slug] = value.translation;
			});

			setTranslations(formatted);
		};

		fetchTranslations();
	}, [language]);

	const translate = (slug, parameters = {}) => {
		if (translations.hasOwnProperty(slug)) {
			let translation = translations[slug];
			for (const parameter in parameters) {
				if (!parameters.hasOwnProperty(parameter)) {
					continue;
				}
				translation = translation.replace(`{${parameter}}`, parameters[parameter]);
			}

			return translation;
		}

		return "...";
	};

	const format = (source, currency = false, options = {}) => {
		const parsedSource = parseFloat(source);
		const defaultOptions = { maximumFractionDigits: 2, ...options };
		let prefix = "";

		if (isNaN(parsedSource)) {
			return "";
		}

		if (currency) {
			defaultOptions.minimumFractionDigits = 2;
			prefix = "EUR "
		}

		return prefix + parsedSource.toLocaleString(language, defaultOptions);
	};

	return (
		<TranslationContext.Provider value={{ translations, translate, format, language }}>
			{props.children}
		</TranslationContext.Provider>
	);
};

TranslationProvider.propTypes = {
	children: PropTypes.any,
	query: PropTypes.object,
	store: PropTypes.object
};

export default compose(
	withApollo,
	withStore
)(TranslationProvider);



// WEBPACK FOOTER //
// ./src/tco/translation.js